import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=4cbd89b0&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=4cbd89b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd89b0",
  null
  
)

export default component.exports